import axios from '@/plugins/axios';
import { KeyWi } from './keywi.model';
import BaseService from '../base-service';

export default class KeyWisService extends BaseService<KeyWi> {
  get endpoint() {
    return 'keywis';
  }
}
